import { QUEST_ICON } from "@/lib/quest";

export function QuestGoals({ goals, big = false }) {
  return (
    <div className={`grid ${big ? "sm:grid-cols-2" : "grid-cols-2"} gap-2.5`} data-testid="quest-goals">
      {goals.map((g) => {
        const pct = Math.min(100, (g.count / g.goal) * 100);
        return (
          <div key={g.kind} className={`rounded-2xl bg-white/10 border ${g.done ? "border-amber-200/70" : "border-white/15"} ${big ? "p-4" : "p-3"}`} data-testid={`quest-goal-${g.kind}`}>
            <p className={`flex items-center justify-between font-bold ${big ? "text-sm" : "text-xs"}`}>
              <span>{QUEST_ICON[g.kind]} {g.label}</span>
              {g.done && <span className="text-amber-200">✓</span>}
            </p>
            <p className={`font-display font-extrabold tabular-nums ${big ? "text-3xl" : "text-xl"}`} data-testid={`quest-goal-${g.kind}-count`}>{g.count.toLocaleString("de-DE")}<span className="text-sm text-red-100 font-bold"> / {g.goal.toLocaleString("de-DE")}</span></p>
            <div className="h-2 rounded-full bg-black/25 overflow-hidden mt-1.5"><div className="h-full rounded-full bg-gradient-to-r from-amber-200 to-white quest-bar" style={{ width: `${pct}%` }} /></div>
          </div>
        );
      })}
    </div>
  );
}
